/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IEveLocaleSwitcherViewProps } from './eve-locale-switcher';

export default (props: IEveLocaleSwitcherViewProps) => {
    if (props.showModal) {
        // if (!props.state.isMobile) {
        return <div className='eve-locale-switcher__background'>{props.modalDisplay}</div>;
        // }
    }
    return <></>;
};
